var map = {
	"./canvas/blocks/custom/contact/admin/BlockPanel.vue": 1036,
	"./canvas/blocks/custom/gridAlfa/admin/BlockPanel.vue": 94280,
	"./canvas/blocks/custom/gridAlfa/admin/LoopItemPanel.vue": 88282,
	"./canvas/blocks/custom/imageHeader/admin/BlockPanel.vue": 54560,
	"./canvas/blocks/custom/imageWithOverlayText/admin/BlockPanel.vue": 2208,
	"./canvas/blocks/custom/imageWithText/admin/BlockPanel.vue": 44234,
	"./canvas/blocks/custom/leftTextImageRight/admin/BlockPanel.vue": 35423,
	"./canvas/blocks/custom/leftTextImageRight/block.js": 76935,
	"./canvas/blocks/custom/leftTextImageRightEqual/admin/BlockPanel.vue": 62481,
	"./canvas/blocks/custom/leftVideoRightColumn/admin/BlockPanel.vue": 13052,
	"./canvas/blocks/custom/sliderAlfa/admin/BlockPanel.vue": 9817,
	"./canvas/blocks/custom/sliderAlfa/admin/LoopItemPanel.vue": 39133,
	"./canvas/blocks/custom/sliderAlfa/block.js": 98885,
	"./canvas/blocks/custom/team/admin/BlockPanel.vue": 83109,
	"./canvas/blocks/custom/team/admin/LoopItemPanel.vue": 66225,
	"./canvas/blocks/custom/video/admin/BlockPanel.vue": 72467,
	"./canvas/blocks/custom/workflow/admin/BlockPanel.vue": 97541,
	"./vendor/canvas/canvas/blocks/utils/text/admin/ckEditorConfig.js": 537
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3078;